import { render } from "./warehouse-delete.vue?vue&type=template&id=3031ca80"
import script from "./warehouse-delete.vue?vue&type=script&lang=js"
export * from "./warehouse-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__